import * as React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

/**
 * Props for {@link MBackdrop}.
 */
interface MBackdropProps {
    /** Whether the backdrop overlay is visible. Defaults to `false`. */
    isOpen?: boolean;
    /** Message rendered next to the spinner. Defaults to `'Loading...'`. */
    message?: string;
}

/**
 * A full-screen MUI {@link Backdrop} with a spinner and message, used to block
 * interaction while an async operation (e.g. a dialog save) is in progress.
 */
const MBackdrop: React.FC<MBackdropProps> = ({ isOpen = false, message = 'Loading...' }) => {
    return (
        <Backdrop open={isOpen} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <CircularProgress color="inherit" />
            <Typography variant="h6" component="div" sx={{ ml: 2 }}>
                {message}
            </Typography>
        </Backdrop>
    );
};

export default MBackdrop;
